<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="info-form" v-if="!showResult&&hasFinished">
                    <div class="box">
                        <h1 class="serviceTestTitle">eAssist Oral Surgery Assessment Test</h1>
                        <p style="margin: 10px 0">Instructions:</p>
                        <div class="mt10 fs14 lh25">Please read each question carefully. Choose the correct answer(s) to each question. Disclaimer: Some
                            questions have more than one correct answer
                        </div>
                        <p class="required" style="margin: 10px 0">* Required</p>
                    </div>

                    <el-form :model="form" :inline="false" :rules="rules" ref="form">
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub0!=3" :src="wrong"></el-image>
                                1) When would you bill Medical Insurance first when a patient is having 3rd molars
                                removed?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item ref="sub0" prop="sub0" class="mt20">
                                <el-radio-group ref="sub0" v-model="form.sub0" :disabled="isAdmin">
                                    <el-radio :label="0">A) When Dental insurance requires a Medical EOB for processing</el-radio><br>
                                    <el-radio :label="1">B) When office is in Network with Medical </el-radio><br>
                                    <el-radio :label="2">C) Never Oral Surgery is not a Medical expense</el-radio><br>
                                    <el-radio :label="3">D) A and B</el-radio>
                                    <el-image v-if="isAdmin&&form.sub0!=3" class="rightPic" :src="right"></el-image><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub1!=1" :src="wrong"></el-image>
                                2) Claim has been processed by Dental, all procedures were covered under the plan,
                                can Medical be billed as secondary insurance for any remaining balance?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub1">
                                <el-radio-group ref="sub1" v-model="form.sub1" :disabled="isAdmin">
                                    <el-radio :label="0">A) Yes</el-radio><br>
                                    <el-radio :label="1">B) No</el-radio><br>
                                    <el-image v-if="isAdmin&&form.sub1!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub2!=0" :src="wrong"></el-image>
                                3) How would you proceed if a dental insurance company asked for a medical EOB?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub2">
                                <el-radio-group ref="sub2" v-model="form.sub2" :disabled="isAdmin">
                                    <el-radio :label="0">A) Bill to medical and submit medical EOB as attachment to dental claim once received</el-radio>
                                    <el-image v-if="isAdmin&&form.sub2!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">B) Close claim and bill the patient for the remaining balance </el-radio><br>
                                    <el-radio :label="2">C) Tell the patient to bill medical and close the dental claim</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub3!=0" :src="wrong"></el-image>
                                4) Can Dental be billed if Medical applied treatment to patient’s deductible?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub3" class="mt20">
                                <el-radio-group ref="sub3" v-model="form.sub3" :disabled="isAdmin">
                                    <el-radio :label="0">A) Yes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub3!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">B) No</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub4!=3" :src="wrong"></el-image>
                                5) Medical applied treatment to patient's deductible, Dental has been billed and no
                                payment is issued by Dental. What possible reason(s) would cause dental to not make a
                                payment? <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub4">
                                <el-radio-group ref="sub4" v-model="form.sub4" :disabled="isAdmin">
                                    <el-radio :label="0">A) Plan Max was reached </el-radio><br>
                                    <el-radio :label="1">B) Dental did not receive the Medical EOB </el-radio><br>
                                    <el-radio :label="2">C) Non Duplication of Benefits provision for Dental Plan </el-radio><br>
                                    <el-radio :label="3">D) All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub4!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub5!=1" :src="wrong"></el-image>
                                6) What Diag Code is routinely used for impacted 3rd molar extractions?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub5">
                                <el-radio-group ref="sub5" v-model="form.sub5" :disabled="isAdmin">
                                    <el-radio :label="0">A) K00.6 </el-radio><br>
                                    <el-radio :label="1">B) K01.1</el-radio>
                                    <el-image v-if="isAdmin&&form.sub5!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">C) K04.1</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub6!=1" :src="wrong"></el-image>
                                7) Where do you usually find the diagnosis code for a biopsy?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub6">
                                <el-radio-group ref="sub6" v-model="form.sub6" :disabled="isAdmin">
                                    <el-radio :label="0">A) Patient's Chart</el-radio><br>
                                    <el-radio :label="1">B) Path Report</el-radio>
                                    <el-image v-if="isAdmin&&form.sub6!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">C) Doctors Narrative - SOAP notes</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub7!=2" :src="wrong"></el-image>
                                8) When submitting a claim to BCBS medical, where would you submit the claim to?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub7">
                                <el-radio-group ref="sub7" v-model="form.sub7" :disabled="isAdmin">
                                    <el-radio :label="0">A) The address on the card</el-radio><br>
                                    <el-radio :label="1">B) Same address as the dental</el-radio><br>
                                    <el-radio :label="2">C) To the home plan address where services were rendered</el-radio>
                                    <el-image v-if="isAdmin&&form.sub7!=2" class="rightPic" :src="right"></el-image><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub8!=3" :src="wrong"></el-image>
                                9) When you submit a medical claim for the removal of 3rd molars, which codes can
                                you use?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub8">
                                <el-radio-group ref="sub8" v-model="form.sub8" :disabled="isAdmin">
                                    <el-radio :label="0">A) CDT codes </el-radio><br>
                                    <el-radio :label="1">B) CDT with ICD-10 codes</el-radio><br>
                                    <el-radio :label="2">C) CPT with ICD-10 codes</el-radio><br>
                                    <el-radio :label="3">D) B or C</el-radio>
                                    <el-image v-if="isAdmin&&form.sub8!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub9!=3" :src="wrong"></el-image>
                                10) When do you submit a claim for a biopsy?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub9" ref="sub9">
                                <el-radio-group ref="sub9" v-model="form.sub9" :disabled="isAdmin">
                                    <el-radio :label="0">A) On the Date of Service</el-radio><br>
                                    <el-radio :label="1">B) When the office asks you too</el-radio><br>
                                    <el-radio :label="2">C) When the doctor provides a narrative </el-radio><br>
                                    <el-radio :label="3">D) When Path report is returned</el-radio>
                                    <el-image v-if="isAdmin&&form.sub9!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub10!=2" :src="wrong"></el-image>
                                11) What attachments would you send with a claim that has billed D7286?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub10">
                                <el-radio-group ref="sub10" v-model="form.sub10" :disabled="isAdmin">
                                    <el-radio :label="0">A) A narrative </el-radio><br>
                                    <el-radio :label="1">B) X-ray </el-radio><br>
                                    <el-radio :label="2">C) Path Report </el-radio>
                                    <el-image v-if="isAdmin&&form.sub10!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">D) Operative Notes</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub11!=1" :src="wrong"></el-image>
                                12) You receive an EOB that denied D9223 stating criteria for benefits not met. You 3 points
                                look at the office insurance verification and it states D9223 covered at 80%. What is
                                your next step?<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub11">
                                <el-radio-group ref="sub11" v-model="form.sub11" :disabled="isAdmin">
                                    <el-radio :label="0">A) Post payment and close the claim</el-radio><br>
                                    <el-radio :label="1">B) Submit an appeal with narrative describing medical necessity for D9223</el-radio>
                                    <el-image v-if="isAdmin&&form.sub11!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">C) Post payment and add note that D9223 was denied as a non covered service</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub12!=0" :src="wrong"></el-image>
                                13) Form CMS1500 is the correct claim form to be used to bill Medical.<span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub12">
                                <el-radio-group ref="sub12" v-model="form.sub12" :disabled="isAdmin">
                                    <el-radio :label="0">A) True </el-radio>
                                    <el-image v-if="isAdmin&&form.sub12!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">B) False</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub13!=3" :src="wrong"></el-image>
                                14) An office has attempted an extraction of a tooth and left root tips for the Oral
                                Surgeon to complete the extraction. What should be the correct billing of these
                                extractions? <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub13">
                                <el-radio-group ref="sub13" v-model="form.sub13" :disabled="isAdmin">
                                    <el-radio :label="0">A) General Dentist Bills D7210/OS bills D7250 </el-radio><br>
                                    <el-radio :label="1">B) General Dentist Bills D7251/0S Bills D7250</el-radio><br>
                                    <el-radio :label="2">C) General Dentist sends no bill/OS Bills D7210</el-radio><br>
                                    <el-radio :label="3">D) General Dentist Bills D7999 with a narrative /OS Bills D7250</el-radio>
                                    <el-image v-if="isAdmin&&form.sub13!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub14!=1" :src="wrong"></el-image>
                                15) Oral Surgeons should bill all extractions using code D7210 or higher due to being a
                                Specialist. <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub14">
                                <el-radio-group ref="sub14" v-model="form.sub14" :disabled="isAdmin">
                                    <el-radio :label="0">A) True </el-radio><br>
                                    <el-radio :label="1">B) False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub14!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub15!=2" :src="wrong"></el-image>
                                16) What attachments should be sent to support the billing of D7241?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub15">
                                <el-radio-group ref="sub15" v-model="form.sub15" :disabled="isAdmin">
                                    <el-radio :label="0">A) X-ray showing of apex of tooth</el-radio><br>
                                    <el-radio :label="1">B) Narrative and/or Operative reports</el-radio><br>
                                    <el-radio :label="2">C) A and B</el-radio>
                                    <el-image v-if="isAdmin&&form.sub15!=2" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub16!=3" :src="wrong"></el-image>
                                17) If proper documents are not sent with the billing of D7210-D7241, what can the
                                insurance company do?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub16">
                                <el-radio-group ref="sub16" v-model="form.sub16" :disabled="isAdmin">
                                    <el-radio :label="0">A) Deny payment of claim</el-radio><br>
                                    <el-radio :label="1">B) Request additional information</el-radio><br>
                                    <el-radio :label="2">C) Downgrade extractions for payment</el-radio><br>
                                    <el-radio :label="3">D) All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub16!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub17!=2" :src="wrong"></el-image>
                                18) You have received an EOB downgrading tooth #1 from D7240 to D7230, what is
                                your next step?
                                <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub17">
                                <el-radio-group ref="sub17" v-model="form.sub17" :disabled="isAdmin">
                                    <el-radio :label="0">A) Apply the payment and notify the office that patient has a remaining balance</el-radio><br>
                                    <el-radio :label="1">B) Apply payment and adjust only for D7240</el-radio><br>
                                    <el-radio :label="2">C) Review clinical notes. If notes support original coding,
                                        submit an appeal with the clinical notes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub17!=2" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub18!=2" :src="wrong"></el-image>
                                19) When deciding to appeal a claim, where would you find the correct address to
                                send information to?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub18">
                                <el-radio-group ref="sub18" v-model="form.sub18" :disabled="isAdmin">
                                    <el-radio :label="0">A) Same address as original claim</el-radio><br>
                                    <el-radio :label="1">B) Address listed on EOB</el-radio><br>
                                    <el-radio :label="2">C) Address provided by insurance company rep for appeals</el-radio>
                                    <el-image v-if="isAdmin&&form.sub18!=2" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub19!=2" :src="wrong"></el-image>
                                20) What information should an office routinely determine prior to billing codes
                                D7280/D7282/D7283?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub19">
                                <el-radio-group ref="sub19" v-model="form.sub19" :disabled="isAdmin">
                                    <el-radio :label="0">A) Determine if procedures are covered benefits</el-radio><br>
                                    <el-radio :label="1">B) Determine if procedures are considered Ortho Benefits</el-radio><br>
                                    <el-radio :label="2">C) A and B</el-radio>
                                    <el-image v-if="isAdmin&&form.sub19!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">D) Nothing, knowing benefits is the patient's responsibility</el-radio>

                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub20!=2" :src="wrong"></el-image>
                                21) What future treatment is typically required for the coverage of D7953?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub20">
                                <el-radio-group ref="sub20" v-model="form.sub20" :disabled="isAdmin">
                                    <el-radio :label="0">A) D2740 </el-radio><br>
                                    <el-radio :label="1">B) D4210 </el-radio><br>
                                    <el-radio :label="2">C) D6010 </el-radio>
                                    <el-image v-if="isAdmin&&form.sub20!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">D) D4266</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub21!=2" :src="wrong"></el-image>
                                22) The office has verified that D9223 is a covered benefit. Will the patient be covered
                                for D9223 and one D7210?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub21">
                                <el-radio-group ref="sub21" v-model="form.sub21" :disabled="isAdmin">
                                    <el-radio :label="0">A) Yes</el-radio><br>
                                    <el-radio :label="1">B) No</el-radio><br>
                                    <el-radio :label="2">C) Dependent upon guidelines of Anesthesia benefits</el-radio>
                                    <el-image v-if="isAdmin&&form.sub21!=2" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub22!=3" :src="wrong"></el-image>
                                23) What conditions may constitute as a Medical Necessity for Anesthesia benefits?
                                (Insurance companies may vary)
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub22">
                                <el-radio-group ref="sub22" v-model="form.sub22" :disabled="isAdmin">
                                    <el-radio :label="0">A) Physically and/or Mentally impaired </el-radio><br>
                                    <el-radio :label="1">B) Asthma</el-radio><br>
                                    <el-radio :label="2">C) Insulin Dependent Diabetic </el-radio><br>
                                    <el-radio :label="3">D) All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub22!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub23!=2" :src="wrong"></el-image>
                                24) The SOAP note in a patient’s chart stands for what?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub23">
                                <el-radio-group ref="sub23" v-model="form.sub23" :disabled="isAdmin">
                                    <el-radio :label="0">A) It means that the clinical notes are finalized and squeaky clean.</el-radio><br>
                                    <el-radio :label="1">B) Nothing, we do not need to read patient clinical notes</el-radio><br>
                                    <el-radio :label="2">C) Subjective, Objective, Assessment and Plan</el-radio>
                                    <el-image v-if="isAdmin&&form.sub23!=2" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub24!=0" :src="wrong"></el-image>
                                25) Billing against Medical Insurance can be an untapped revenue source for a Dental Practice
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub24">
                                <el-radio-group ref="sub24" v-model="form.sub24" :disabled="isAdmin">
                                    <el-radio :label="0">A) True </el-radio>
                                    <el-image v-if="isAdmin&&form.sub24!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">B) False</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div>Use this EOB to answer the following questions</div>
                            <el-image :src="picSub26" style="width: 80%"></el-image>
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub25!=0" :src="wrong"></el-image>
                                26) By looking at this claim, would this be a dental or medical payment?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub25">
                                <el-radio-group ref="sub25" v-model="form.sub25" :disabled="isAdmin">
                                    <el-radio :label="0">Medical</el-radio>
                                    <el-image v-if="isAdmin&&form.sub25!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Dental</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div>Please use the claim below to answer the following questions</div>
                            <el-image :src="picSub27" style="width: 80%"></el-image>
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub26!=3" :src="wrong"></el-image>
                                27) What necessary information is missing from this claim?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub26">
                                <el-radio-group ref="sub26" v-model="form.sub26" :disabled="isAdmin">
                                    <el-radio :label="0">A) Diagnosis Code</el-radio><br>
                                    <el-radio :label="1">B) Date of Procedure</el-radio><br>
                                    <el-radio :label="2">C) Tax ID</el-radio><br>
                                    <el-radio :label="3">D) A&C</el-radio>
                                    <el-image v-if="isAdmin&&form.sub26!=3" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="4">E) All of the above</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub27!=1" :src="wrong"></el-image>
                                28) Would you send any radiographs with this claim?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub27">
                                <el-radio-group ref="sub27" v-model="form.sub27" :disabled="isAdmin">
                                    <el-radio :label="0">Yes </el-radio><br>
                                    <el-radio :label="1">No</el-radio>
                                    <el-image v-if="isAdmin&&form.sub27!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div>Please use the EOB below to answer the following questions</div>
                            <el-image :src="picSub29" style="width: 80%"></el-image>
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub28!=0" :src="wrong"></el-image>
                                29) Is this claim appealable?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub28">
                                <el-radio-group ref="sub28" v-model="form.sub28" :disabled="isAdmin">
                                    <el-radio :label="0">Yes </el-radio>
                                    <el-image v-if="isAdmin&&form.sub28!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest">
                                30) If so, what information would you compile or collect to write an appeal?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub29" class="mt10">
                                <el-input ref="sub29" v-model="form.sub29" :disabled="isAdmin"></el-input>
                            </el-form-item>

                        </div>

                        <div class="box">
                            <div>Use the x-ray below to answer the following question.</div>
                            <el-image :src="picSub31" style="width: 80%"></el-image>
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub30!=2" :src="wrong"></el-image>
                                31) What would you do when you see this x-ray is the only x-ray in the patient s file
                                and the claim that you have to send is for 4 - 7240s?
                                <span class="required">*</span></div>
                            <div class="score" >4 points</div>
                            <el-form-item prop="sub30">
                                <el-radio-group ref="sub30" v-model="form.sub30" :disabled="isAdmin">
                                    <el-radio :label="0">A) Send claim with x-ray and see how insurance processes first</el-radio><br>
                                    <el-radio :label="1">B) Send claim without x-ray</el-radio><br>
                                    <el-radio :label="2">C) Call the office to clarify before sending </el-radio>
                                    <el-image v-if="isAdmin&&form.sub30!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">D) Don't see anything wrong with this x-ray</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box" >
                            <div>Please use the EOB below to answer the following questions (PLEASE NOTE: Following 2 images
                                are closeups of this EOB)</div>
                            <el-image :src="picSub32_1" style="width: 80%"></el-image>
                            <div style="margin: 10px 0">close up of above EOB</div>
                            <el-image :src="picSub32_2" style="width: 80%"></el-image>
                            <div style="margin: 10px 0">close up of EOB</div>
                            <el-image :src="picSub32_3" style="width: 80%"></el-image>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&!(form.sub31=='40'||form.sub31=='40.00'||form.sub31=='$40'||form.sub31=='$40.00')" :src="wrong"></el-image>
                                32) What is the patient balance?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub31" class="mt10">
                                <el-input ref="sub31" v-model="form.sub31" :style="{width:isAdmin?'45%':'90%'}" :disabled="isAdmin"></el-input>
                                <el-input :disabled="isAdmin" v-model="correctAnswer0" :style="{width:isAdmin?'45%':'90%','margin-left':'10px',display:isAdmin?'inline-block':'none'}"></el-input>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&isAdmin&&!(form.sub32=='643'||form.sub32=='643.00'||form.sub32=='$643'||form.sub32=='$643.00')" :src="wrong"></el-image>
                                33) What is write off amount?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub32"  class="mt10">
                                <el-input ref="sub32" v-model="form.sub32" :style="{width:isAdmin?'45%':'90%'}" :disabled="isAdmin"></el-input>
                                <el-input :disabled="isAdmin" v-model="correctAnswer1" :style="{width:isAdmin?'45%':'90%','margin-left':'10px',display:isAdmin?'inline-block':'none'}"></el-input>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div>Please use x-Ray below to answer the following questions</div>
                            <el-image :src="picSub34" style="width: 40%" class="mt10"></el-image>
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub33!=4" :src="wrong"></el-image>
                                34) You received a denial from insurance for D6010 on tooth #7. What do you see in
                                the x-ray that would help you write an appeal to explain why the extraction was
                                necessary and thus the implant to be placed?
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub33">
                                <el-radio-group ref="sub33" v-model="form.sub33" :disabled="isAdmin">
                                    <el-radio :label="0">A) Abscess at root tip </el-radio><br>
                                    <el-radio :label="1">B) Failing root canal</el-radio><br>
                                    <el-radio :label="2">C) Largely decayed and non-restorable</el-radio><br>
                                    <el-radio :label="3">D) Nothing visible to warrant D6010.</el-radio><br>
                                    <el-radio :label="4">E) B and C</el-radio>
                                    <el-image v-if="isAdmin&&form.sub33!=4" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="btnLayout">
                            <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                            <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                        </div>
                    </el-form>
                </div>

                <div class="box" v-if="showResult&&hasFinished">
                    <h1 class="serviceTestTitle">eAssist Oral Surgery Assessment Test</h1>
                    <!--
                    <span>Of the parts of this exam that can be automatically graded you have recieved </span>
                    <span>{{correctNum}}</span>/{{totalNum}} ({{correctPercent}})-->
                    <span>Thank you for completing this knowledge assessment!</span><br/>
                    <span>Please allow up to three business days while we review your application.</span>
                    <br>
                    <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
                </div>
            </section>
        </div>
        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader"
    import Side from '../../components/Aside.vue'
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import picSub34 from "../../assets/pic/oralTest_sub34.jpg"
    import picSub32_1 from "../../assets/pic/oralTest_sub32_1.jpg"
    import picSub32_2 from "../../assets/pic/oralTest_sub32_2.jpg"
    import picSub32_3 from "../../assets/pic/oralTest_sub32_3.jpg"
    import picSub31 from "../../assets/pic/oralTest_sub31.jpg"
    import picSub29 from "../../assets/pic/oralTest_sub29.png"
    import picSub27 from "../../assets/pic/oralTest_sub27.jpg"
    import picSub26 from "../../assets/pic/oralTest_sub26.jpg"
    import { chat2Ascii } from "../../../static/js/util"
    export default {
        name: "oralSurgeryTest",
        components:{ApplyHeader,Side},
        data(){
            return{
                loading:false,
                picSub34:picSub34,
                picSub32_1:picSub32_1,
                picSub32_2:picSub32_2,
                picSub32_3:picSub32_3,
                picSub31:picSub31,
                picSub29:picSub29,
                picSub27:picSub27,
                picSub26:picSub26,
                wrong:wrong,
                right:right,
                exitVisible:false,
                confirmVisible:false,
                showResult:false,
                hasFinished:false,
                smallScreen:false,
                correctNum:0,
                totalNum:34,
                form:{
                    sub29:'',
                    sub31:'',
                    sub32:'',
                },
                isAdmin:false,
                /**表单验证规则，所有选项都不允许为空  第10题和第26题如果一个都没有选也会提示**/
                rules: {
                    sub0: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub1: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub2: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub3: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub4: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub5: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub6: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub7: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub8: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub9: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub10: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub11: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub12: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub13: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub14: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub15: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub16: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub17: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub18: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub19: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub20: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub21: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub22: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub23: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub24: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub25: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub26: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub27: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub28: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub29: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub30: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub31: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub32: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub33: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ]
                },
                correctAnswer0:'40/40.00/$40/$40.00',
                correctAnswer1:'643/643.00/$643/$643.00'
            }
        },
        computed:{
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                let per = Number(100*this.correctNum/this.totalNum).toFixed(2)
                return per+'%'
            },
            correctBalance(){
                return function (form,num) {
                    return this.coverBalance(form,num)&&this.coverBalance(form,num+'.00')
                        &&this.coverBalance(form,'$'+num)&&this.coverBalance(form,'$'+num+'.00')
                }

            },
            getHeight(){
                return document.documentElement.clientHeight
            }
        },
        methods:{
            getUserAnswerData(id,email){
                console.log('id',id);
                console.log('email',email);
                this.loading=true
                this.$axios.get(this.$URL.gradeUrl,{params:{serviceId:id,email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        console.log('用户答题数据',res)
                        /**取到用户答题数据重构form显示答题详情**/
                        if(res.data!=null){
                            var list = res.data.detail
                            for(var i=0;i<list.length;i++){
                                this.$set(this.form,('sub'+i),list[i])
                            }
                            this.calScore()
                        }
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            getData(){
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                    var serviceId = this.$route.query.serviceId
                    var email = this.$route.query.email
                     var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                         this.$router.push('/login')
                        return
                    }
                    this.getUserAnswerData(serviceId,email)
                    this.isAdmin=true
                    return
                }
                var storeService = this.$store.state.serviceInfo
                //when no serviceid info, go back to service list
                console.log('get serviceId:' + storeService.serviceId)
                if(storeService.serviceId == undefined){
                    this.$router.push({path:'/service'})
                    return
                }
                var user = localStorage.getItem('email')
                this.getUserAnswerData(storeService.serviceId,user)
                var status = storeService.status
                if(status==2||status==3){
                    this.showResult=true
                    this.passPercent = (((storeService.servicePassScore||0)/this.totalNum).toFixed(2)*100)+'%'
                }
            },
            coverBalance(subStr,str){
                var reg = eval("/"+subStr+"/ig");
                return reg.test(str);
            },
            calScore(){//算正确分数 总分80
                var score=0
                this.correctNum=0
                if(this.form.sub0==3) {score += 3;this.correctNum++}
                if(this.form.sub1==1) {score += 3;this.correctNum++}
                if(this.form.sub2==0) {score += 3;this.correctNum++}
                if(this.form.sub3==0) {score += 3;this.correctNum++}
                if(this.form.sub4==3) {score += 3;this.correctNum++}
                if(this.form.sub5==1) {score += 3;this.correctNum++}
                if(this.form.sub6==1) {score += 3;this.correctNum++}
                if(this.form.sub7==2) {score += 3;this.correctNum++}
                if(this.form.sub8==3) {score += 3;this.correctNum++}
                if(this.form.sub9==3) {score += 3;this.correctNum++}
                if(this.form.sub10==2) {score += 3;this.correctNum++}
                if(this.form.sub11==1) {score += 3;this.correctNum++}
                if(this.form.sub12==0) {score += 3;this.correctNum++}
                if(this.form.sub13==3) {score += 3;this.correctNum++}
                if(this.form.sub14==1) {score += 3;this.correctNum++}
                if(this.form.sub15==2) {score += 3;this.correctNum++}
                if(this.form.sub16==3) {score += 3;this.correctNum++}
                if(this.form.sub17==2) {score += 2;this.correctNum++}
                if(this.form.sub18==2) {score += 3;this.correctNum++}
                if(this.form.sub19==2) {score += 3;this.correctNum++}
                if(this.form.sub20==2) {score += 3;this.correctNum++}
                if(this.form.sub21==2) {score += 3;this.correctNum++}
                if(this.form.sub22==3) {score += 3;this.correctNum++}
                if(this.form.sub23==2) {score += 3;this.correctNum++}
                if(this.form.sub24==0) {score += 3;this.correctNum++}
                if(this.form.sub25==0) {score += 3;this.correctNum++}
                if(this.form.sub26==3) {score += 3;this.correctNum++}
                if(this.form.sub27==1) {score += 3;this.correctNum++}
                if(this.form.sub28==0) {score += 3;this.correctNum++}
                if(this.form.sub29) {score += 1;this.correctNum++}
                if(this.form.sub30==2) {score += 4;this.correctNum++}
                if(this.form.sub31=='40'||this.form.sub31=='40.00'||this.form.sub31=='$40.00'||this.form.sub31=='$40') {score += 3;this.correctNum++}
                if(this.form.sub32=='643'||this.form.sub32=='643.00'||this.form.sub32=='$643'||this.form.sub32=='$643.00') {score += 3;this.correctNum++}
                if(this.form.sub33==4) {score += 3;this.correctNum++}
                return score
            },
            goPre(){
                this.$router.go(-1)
            },
            goBack(){
                this.$router.push({path:'/service'})
            },
            cancel(){
                this.exitVisible=true
            },
            submit(){
                this.confirmVisible=false
                var score=0
                var list=[]
                var len = Object.keys(this.form).length
                for(var i=0;i<len;i++){
                    list.push(this.form['sub'+i])
                }
                score = this.calScore()
                var storeService = this.$store.state.serviceInfo
                //var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = 100
                params.positionId = 0
                params.status = score > storeService.servicePassScore ? 1: 0
                params.detail = JSON.stringify(list)
                params.applicantEmail=localStorage.getItem('email')
                this.loading=true
                this.$axios.post(this.$URL.serviceTestUrl,params).then(res=>{
                    this.loading=false
                    if(res.code==0){
                        this.goBack()
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            submitPrepare(){
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            console.log('submit',this.form)
                            this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
        },
        mounted() {
            var clientW = document.documentElement.clientWidth
            if(clientW<1220){
                this.smallScreen=true
            }
            this.getData()
        },
        watch:{
            '$route'(to,from){
                console.log(from.path)
                if(to.path==='/oralSurgeryTest'){
                    this.getData()
                }
            }
        }
    }
</script>

<style scoped>
    .rightPic{
        width: 20px;
        position: absolute;
        right: 20px
    }
    .el-radio{
        width:200px;
        height:43px;
        line-height:20px!important;
    }
    .radioText{
        display: inline-block;
    }
    .box>>>.el-radio__label{
        vertical-align: middle!important;
    }
    .btnLayout{
        margin:10px 0 20px 15px
    }
    @media screen and (max-width: 1440px) {
        .btnLayout{
            margin:10px 0 20px 5px
        }
    }
    @media screen and (max-width: 1200px) {
        .btnLayout{
            margin:10px 0 20px 0px
        }
    }
</style>